import {
    Component,
    computed,
    inject
} from '@angular/core';

import {
    NzIconModule
} from 'ng-zorro-antd/icon';

import {
    NzProgressModule
} from 'ng-zorro-antd/progress';

import {
    NzTableModule
} from 'ng-zorro-antd/table';

import {
    NzButtonModule
} from 'ng-zorro-antd/button';

import {
    RestaurantContextService
} from '../../core/restaurant/services/restaurant-context.service';


interface KpiCard {

    title: string;

    value: string;

    description: string;

    trend: string;

    positive: boolean;

    icon: string;

    iconClass: string;
}


interface SalesDay {

    label: string;

    amount: string;

    percent: number;
}


interface RecentOrder {

    id: string;

    table: string;

    customer: string;

    total: string;

    status:
        | 'En cocina'
        | 'Listo'
        | 'Entregado'
        | 'Cancelado';

    elapsed: string;
}


interface KitchenOrder {

    id: string;

    product: string;

    table: string;

    minutes: number;

    status: string;
}


@Component({
    selector: 'app-dashboard',

    imports: [
        NzIconModule,
        NzProgressModule,
        NzTableModule,
        NzButtonModule
    ],

    templateUrl: './dashboard.html',

    styleUrl: './dashboard.css'
})
export class Dashboard {

    private readonly restaurantContext =
        inject(
            RestaurantContextService
        );


    readonly selectedRestaurant =
        this.restaurantContext
            .selectedRestaurant;


    readonly selectedBranch =
        this.restaurantContext
            .selectedBranch;


    readonly branchesLoading =
        this.restaurantContext
            .branchesLoading;


    readonly restaurantName =
        computed(() =>
            this.selectedRestaurant()
                ?.name
            ?? 'Sin restaurante'
        );


    readonly branchName =
        computed(() => {

            if (
                this.branchesLoading()
            ) {

                return 'Cargando sucursal...';
            }


            return this.selectedBranch()
                ?.name
            ?? 'Sin sucursal';
        });


    readonly contextDescription =
        computed(() => {

            const restaurant =
                this.selectedRestaurant();

            const branch =
                this.selectedBranch();


            if (
                !restaurant
            ) {

                return 'Selecciona un restaurante para comenzar.';
            }


            if (
                !branch
            ) {

                return restaurant.name;
            }


            return `${restaurant.name} · ${branch.name}`;
        });


    readonly kpis: KpiCard[] = [

        {
            title: 'Ventas de hoy',

            value: 'S/ 12,480',

            description: 'vs. S/ 11,120 ayer',

            trend: '+12%',

            positive: true,

            icon: 'rise',

            iconClass:
                'bg-[#fff0ea] text-[#d95235]'
        },

        {
            title: 'Pedidos activos',

            value: '18',

            description:
                '6 esperando preparación',

            trend: '+8%',

            positive: true,

            icon: 'shopping-cart',

            iconClass:
                'bg-[#fff3ee] text-[#c94d33]'
        },

        {
            title: 'Mesas ocupadas',

            value: '12 / 18',

            description:
                '67% de ocupación',

            trend: '+20%',

            positive: true,

            icon: 'appstore',

            iconClass:
                'bg-[#fff4e8] text-[#df7a38]'
        },

        {
            title: 'Ticket promedio',

            value: 'S/ 54.80',

            description:
                'vs. S/ 50.70 ayer',

            trend: '+8%',

            positive: true,

            icon: 'wallet',

            iconClass:
                'bg-[#f8eee9] text-[#94513c]'
        }

    ];


    readonly sales: SalesDay[] = [

        {
            label: 'Lun',
            amount: 'S/ 7,800',
            percent: 44
        },

        {
            label: 'Mar',
            amount: 'S/ 9,500',
            percent: 57
        },

        {
            label: 'Mié',
            amount: 'S/ 8,200',
            percent: 49
        },

        {
            label: 'Jue',
            amount: 'S/ 11,200',
            percent: 68
        },

        {
            label: 'Vie',
            amount: 'S/ 10,100',
            percent: 61
        },

        {
            label: 'Sáb',
            amount: 'S/ 14,600',
            percent: 86
        },

        {
            label: 'Dom',
            amount: 'S/ 16,200',
            percent: 100
        }

    ];


    readonly recentOrders: RecentOrder[] = [

        {
            id: '#1046',

            table: 'Mesa 7',

            customer: 'Ana Torres',

            total: 'S/ 89.00',

            status: 'En cocina',

            elapsed: '2 min'
        },

        {
            id: '#1045',

            table: 'Mesa 4',

            customer: 'Diego López',

            total: 'S/ 64.50',

            status: 'En cocina',

            elapsed: '4 min'
        },

        {
            id: '#1044',

            table: 'Mesa 3',

            customer: 'Luis Ramírez',

            total: 'S/ 72.00',

            status: 'Listo',

            elapsed: '8 min'
        },

        {
            id: '#1043',

            table: 'Mesa 8',

            customer: 'Mariela Soto',

            total: 'S/ 56.00',

            status: 'Entregado',

            elapsed: '12 min'
        },

        {
            id: '#1042',

            table: 'Mesa 5',

            customer: 'Juan Pérez',

            total: 'S/ 51.00',

            status: 'Cancelado',

            elapsed: '18 min'
        }

    ];


    readonly kitchenOrders: KitchenOrder[] = [

        {
            id: '#1042',

            product: 'Lomo Saltado',

            table: 'Mesa 5',

            minutes: 2,

            status: 'En preparación'
        },

        {
            id: '#1043',

            product: 'Ají de Gallina',

            table: 'Mesa 8',

            minutes: 4,

            status: 'En preparación'
        },

        {
            id: '#1044',

            product: 'Ceviche clásico',

            table: 'Mesa 3',

            minutes: 6,

            status: 'Por iniciar'
        },

        {
            id: '#1045',

            product: 'Arroz con pollo',

            table: 'Mesa 7',

            minutes: 8,

            status: 'Por iniciar'
        }

    ];
}